var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "white--text important-links pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-container",
        [
          _c(
            "v-row",
            { attrs: { justify: "space-between", dense: "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "6", sm: "6" } },
                [
                  _c("strong", [
                    _c(
                      "a",
                      {
                        staticClass: "no-decoration white--text",
                        attrs: {
                          href: _vm.$t("footer.privacyPolicyPdf"),
                          target: "_blank"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("footer.privacyPolicy")))]
                    )
                  ]),
                  _vm._v("  |  "),
                  _c(
                    "strong",
                    [
                      _c(
                        "RouterLink",
                        {
                          staticClass: "no-decoration white--text",
                          attrs: { to: "/ticket-validation" }
                        },
                        [_vm._v(_vm._s(_vm.$t("footer.ticketValidation")))]
                      )
                    ],
                    1
                  ),
                  _c("v-icon", { attrs: { dark: "" } }, [
                    _vm._v(" mdi-verified ")
                  ])
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "text-right", attrs: { cols: "6", sm: "6" } },
                [
                  _c(
                    "a",
                    {
                      staticClass: "no-decoration white--text mr-2",
                      attrs: {
                        href: "https://www.botanickaliberec.cz",
                        target: "_blank"
                      }
                    },
                    [
                      _c("img", {
                        staticStyle: { "vertical-align": "middle" },
                        attrs: {
                          src: require("../../assets/web.svg"),
                          width: "24"
                        }
                      })
                    ]
                  ),
                  _c("span", { staticClass: "mr-3" }, [
                    _c(
                      "a",
                      {
                        staticClass: "no-decoration white--text",
                        attrs: {
                          href: "https://www.botanickaliberec.cz",
                          target: "_blank"
                        }
                      },
                      [_vm._v("botanickaliberec.cz")]
                    )
                  ]),
                  _c(
                    "a",
                    {
                      staticClass: "no-decoration white--text",
                      attrs: {
                        href:
                          "https://www.facebook.com/people/Botanick%C3%A1-zahrada-Liberec-LK/100089513884174/",
                        target: "_blank"
                      }
                    },
                    [
                      _c("img", {
                        staticStyle: { "vertical-align": "middle" },
                        attrs: {
                          src: require("../../assets/fb.svg"),
                          width: "24"
                        }
                      })
                    ]
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }